import api from './apiClient';
import {
  MedicalControl,
  Vaccination,
  VaccinationCreate,
  MedicalRecord,
  GroomControl,
} from '../types';

export const medicalService = {
  getMedicalControls: async (petId: number): Promise<MedicalControl[]> => {
    const response = await api.get(`/medical/controls/${petId}`);
    return response.data;
  },

  createMedicalControl: async (petId: number, controlData: Partial<MedicalControl>): Promise<MedicalControl> => {
    const response = await api.post(`/medical/controls?pet_id=${petId}`, controlData);
    return response.data;
  },

  updateMedicalControl: async (controlId: number, controlData: Partial<MedicalControl>): Promise<MedicalControl> => {
    const response = await api.put(`/medical/controls/${controlId}`, controlData);
    return response.data;
  },

  deleteMedicalControl: async (controlId: number): Promise<void> => {
    await api.delete(`/medical/controls/${controlId}`);
  },

  getVaccinations: async (petId: number): Promise<Vaccination[]> => {
    const response = await api.get(`/medical/vaccinations/${petId}`);
    return response.data;
  },

  createVaccination: async (petId: number, vaccinationData: VaccinationCreate): Promise<Vaccination> => {
    const response = await api.post(`/medical/vaccinations?pet_id=${petId}`, vaccinationData);
    return response.data;
  },

  updateVaccination: async (vaccinationId: number, vaccinationData: Partial<Vaccination>): Promise<Vaccination> => {
    const response = await api.put(`/medical/vaccinations/${vaccinationId}`, vaccinationData);
    return response.data;
  },

  deleteVaccination: async (vaccinationId: number): Promise<void> => {
    await api.delete(`/medical/vaccinations/${vaccinationId}`);
  },

  getMedicalRecords: async (petId: number): Promise<MedicalRecord[]> => {
    const response = await api.get(`/medical/records/${petId}`);
    return response.data;
  },

  createMedicalRecord: async (petId: number, recordData: Partial<MedicalRecord>): Promise<MedicalRecord> => {
    const response = await api.post(`/medical/records?pet_id=${petId}`, recordData);
    return response.data;
  },

  updateMedicalRecord: async (recordId: number, recordData: Partial<MedicalRecord>): Promise<MedicalRecord> => {
    const response = await api.put(`/medical/records/${recordId}`, recordData);
    return response.data;
  },

  deleteMedicalRecord: async (recordId: number): Promise<void> => {
    await api.delete(`/medical/records/${recordId}`);
  },

  getGroomControls: async (petId: number): Promise<GroomControl[]> => {
    const response = await api.get(`/medical/groom-controls/${petId}`);
    return response.data;
  },

  createGroomControl: async (petId: number, groomControlData: Partial<GroomControl>): Promise<GroomControl> => {
    const response = await api.post(`/medical/groom-controls?pet_id=${petId}`, groomControlData);
    return response.data;
  },

  updateGroomControl: async (groomControlId: number, groomControlData: Partial<GroomControl>): Promise<GroomControl> => {
    const response = await api.put(`/medical/groom-controls/${groomControlId}`, groomControlData);
    return response.data;
  },

  deleteGroomControl: async (groomControlId: number): Promise<void> => {
    await api.delete(`/medical/groom-controls/${groomControlId}`);
  },

  getLastArchivedYear: async (petId: number): Promise<{ year: number | null }> => {
    const response = await api.get(`/medical/archive/${petId}/last-year`);
    return response.data;
  },

  getDaysUntilArchive: async (petId: number): Promise<{ days_remaining: number; years: number; months: number; days: number } | null> => {
    const response = await api.get(`/medical/archive/${petId}/days-until`);
    return response.data;
  },

  getAllArchivedRecords: async (petId: number): Promise<{
    controls: any[];
    vaccinations: any[];
    records: any[];
    grooms: any[];
  }> => {
    const response = await api.get(`/medical/archive/${petId}/all`);
    return response.data;
  },

  getArchivedRecordsByYear: async (petId: number, year: number): Promise<{
    controls: any[];
    vaccinations: any[];
    records: any[];
    grooms: any[];
    year: number;
  }> => {
    const response = await api.get(`/medical/archive/${petId}/year/${year}`);
    return response.data;
  },

  getAvailableYears: async (petId: number): Promise<{ years: number[] }> => {
    const response = await api.get(`/medical/${petId}/available-years`);
    return response.data;
  },

  sendTestArchivePdf: async (petId?: number, email?: string, userId?: number): Promise<{
    message: string;
    pet_name: string;
    email: string;
  }> => {
    const url = `/medical/archive/test-pdf`;
    const response = await api.post(url, {
      pet_id: petId || null,
      user_id: userId || null,
      email: email || null,
    });
    return response.data;
  },
};








